import cn from 'classnames';

// Пункт карточки PillDropdown: ссылка (кошельки) или кнопка (языки). Выбранный
// пункт — цветом акцента. Отдельным файлом: модуль с компонентом должен
// экспортировать только компоненты (react-refresh).
export const pillDropdownItemClassName = (selected = false) =>
  cn(
    'block w-full whitespace-nowrap rounded-control px-3 py-2 text-left text-[13px] font-semibold hover:bg-surface-hover',
    selected ? 'text-content-accent' : 'text-content-primary',
  );
